import axios, { AxiosRequestConfig } from 'axios';
import UserModule from '@/store/modules/user';
import { ApiResponseData } from './apiModels';
import qs from 'qs';
import { Modal, message } from 'ant-design-vue';

interface ApiRequestOptions extends AxiosRequestConfig {
  reqName?: string;
  headers?: { [key: string]: any };
  data?: any;
}

export interface ILoginReturnData {
  userName: string;
  access_token: string;
  expires_in: number;
  token_type: string;
}

const defaultAxiosOptions: AxiosRequestConfig = {
  //baseURL: 'https://spider.ch2lab.cn:1443',
  baseURL: process.env.VUE_APP_ROOT,
  //baseURL: '/api',
  timeout: 1000 * 60 * 5,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Access-Control-Allow-Origin': '*',
  },
  maxContentLength: 1024 * 1024 * 20,
  method: 'GET',
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
};

const apiAxios = axios.create(defaultAxiosOptions);
apiAxios.interceptors.request.use(
  config => {
    if (config.method === 'get') {
      const time = new Date().getTime();
      if (config.params) {
        config.params = Object.assign(config.params, { t: time });
      } else {
        config.params = { t: time };
      }
    }
    if (UserModule.getToken) {
      config.headers.Authorization = 'Bearer ' + UserModule.getToken;
    }
    return config;
  },
  error => {
    // Handle request error here
    // Promise.reject(error);
  }
);

// respone 拦截器
apiAxios.interceptors.response.use(
  response => {
    const { data } = response;
    if (data.code === 401) {
      Modal.info({
        content: '您的登录凭证已经过期，请重新登录',
        title: '重新登录',
        okText: '重新登录',
        onOk: () => {
          UserModule.LogOut().then(() => {
            sessionStorage.clear();
            location.href = '/';
          });
        },
      });
    }
    if (Object.keys(data).indexOf('code') >= 0) {
      if (data.code !== 200) {
        console.log(`服务器操作错误：`, data);
        message.error(`错误，code=${data.code}.${data.message ? data.message : data.data}`);
        throw new Error(data.message || data.data);
      }
    }
    return response;
  },
  error => {
    let msg = error.toString();
    // message.error({ content: error.response.data.message, duration: 3 * 1000 });
    if (error.response) {
      console.log('API ERROR error.response:', error.response);
      switch (error.response.status) {
        case 401:
          Modal.info({
            content: '您的登录凭证已经过期，请重新登录',
            title: '重新登录',
            okText: '重新登录',
            onOk: () => {
              UserModule.LogOut().then(() => {
                sessionStorage.clear();
                location.href = '/';
              });
            },
          });

          break;
        case 403:
          msg = `code=403: ${error.response.data.message}`;
          message.error(msg);
          break;
        case 500:
          msg = `code=500: 服务器错误:${error.response.data} `;
          console.log(msg, error);
          message.error(msg);
          break;
        default:
          msg = `code=403: ${error.response.data.message}`;
          message.error(msg);
      }
    } else {
      console.log('API ERROR:', error);
      Modal.confirm({ content: `错误:response=${error}`, title: '错误' });
    }
    return Promise.reject(msg);
  }
);

async function apiRequest<R>(reqOptions: ApiRequestOptions): Promise<R> {
  const options = Object.assign(defaultAxiosOptions, reqOptions);

  const promise = new Promise(async (resolve, reject) => {
    try {
      const res = await apiAxios(options);
      resolve(res.data as R);
    } catch (error) {
      reject(error);
    }
  });

  return promise as Promise<R>;
  // return apiAxios( reqOptions ) as any as Promise<R>;
}

async function apiSendAsync<R>(method: string, url: string, data: any, params: any): Promise<R> {
  const options = Object.assign(defaultAxiosOptions, {
    url,
    method,
    data: JSON.stringify(data),
    params,
  });

  const promise = new Promise(async (resolve, reject) => {
    try {
      const res = await apiAxios(options);
      resolve(res.data as R);
    } catch (error) {
      reject(error);
    }
  });
  return promise as Promise<R>;
}
export default apiRequest;
export { apiRequest, ApiRequestOptions, apiSendAsync };
